import React from 'react';

export default function Arrow({className}) {
  return (
    <svg className={' ' +className} width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_200_32)">
    <path d="M3.02746 8.9739H-3.05176e-05L-3.05176e-05 5.98563H3.02746L3.02746 8.9739ZM5.98171 0L9.00909 0L9.00909 2.99736L11.9725 2.99736L11.9725 5.98563L9.00909 5.98563L9.00909 21H5.98171L5.98171 5.98563L3.02746 5.98563L3.02746 2.99736L5.98171 2.99736L5.98171 0ZM15 8.9739H11.9725L11.9725 5.98563H15L15 8.9739Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_200_32">
    <rect width="15" height="21" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  );
}
